import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { useHistory } from 'react-router-dom';
import Accordion from '../../../../components/Accordion';

import { getGrauParentesco, validaCpfDuplicidade } from '../../../../services';

import { useGlobal } from '../../../../contexts/Global/context';
import { useDependente } from '../../../../contexts/InclusaoDependente/context';
import { useTitular } from '../../../../contexts/InclusaoTitular/context';

import Input from '../../../../components/Inputs/Input';
import StepProgress from '../../../../components/StepProgress';
import InputTag from '../../../../components/Inputs/InputTag';
import Button from '../../../../components/Button';
import Divider from '../../../../components/Divider';
import Icon from '../../../../components/Icons';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import Select from '../../../../components/Inputs/Select';
import Radio from '../../../../components/Inputs/Radio';

import steps from '../../../../utils/steps.json';
import schema from './schema';
import validate from './validate';

import { cloneObject } from '../../../../utils';
import MensagensAlertas from '../Alertas';
import Modal from '../../../../components/Modal';
import validators from '../../../../utils/defaultValidators';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

import * as S from './styles';

import FormContainer from '../../../../components/FormContainer';

function Dependente() {
    const history = useHistory();

    const { dataActiveContract, staticOptions, contrastTheme } = useGlobal();
    const { dataTitular, flow } = useTitular();
    const { kinshipDegreeOptions, setKinshipDegreeOptions, dataDependentes, setDataDependentes } = useDependente();
    const [activeHealthPlan, setActiveHealthPlan] = React.useState('');

    const alreadyHasTitular = flow === 'selecionar_titular';

    const { referenciaMovimentacao } = dataActiveContract;

    let dateStartPlanSuggestedValue = dataTitular.dateStartPlan?.value;

    useEffect(() => {
        setActiveHealthPlan(dataTitular.healthPlan?.value);
    }, [dataTitular]);

    if (flow === 'selecionar_titular')
        dateStartPlanSuggestedValue = referenciaMovimentacao.dataInclusao ? referenciaMovimentacao.dataInclusao : null;

    function validateCpfAge(newDataDependentes, value, index) {
        if (index) newDataDependentes = newDataDependentes[index];
        const dataMaxima = moment(new Date().toISOString()).subtract(18, 'year');
        const dataDigitada = moment(value);

        const isOfAge = dataDigitada < dataMaxima;

        if (!isOfAge && !newDataDependentes.cpf.value) {
            newDataDependentes.cpf.unmaskedValue = new Date().getTime().toString().slice(0, 11);
            newDataDependentes.cpf.isFake = true;
        }

        newDataDependentes.cpf.required = isOfAge;
        newDataDependentes.cpf.error = '';

        validators.cpf(newDataDependentes);
    }

    function getInitialValuesDependent(dependentSchema) {
        if (dependentSchema.birth.value) validateCpfAge(dependentSchema, dependentSchema.birth.value);

        return {
            ...dependentSchema,
            lackGroup: {
                ...dependentSchema.lackGroup,
                required:
                    dataActiveContract.isAdesao &&
                    (!dataActiveContract.parametros.tipoMovimentacaoCadastral === 'T' ||
                        !(
                            dataActiveContract.parametros.tipoMovimentacaoCadastral !== 'T' &&
                            dataActiveContract.parametros.possuiAutonomiaIsencaoCarencia
                        )),
                options: [],
            },
            cid: {
                ...dependentSchema.cid,
                error: '',
            },
            healthPlan: {
                ...dependentSchema.healthPlan,
                value: dataTitular.healthPlan?.value,
                lookup: dataTitular.healthPlan?.lookup,
            },
            dateStartPlan: {
                ...dependentSchema.dateStartPlan,
                value: dateStartPlanSuggestedValue,
                disabled: (dataActiveContract.isPj || dataActiveContract.isLicitacao) && dateStartPlanSuggestedValue,
            },
            stateService: {
                ...dependentSchema.stateService,
                value: dataTitular?.stateService?.lookup,
            },
            countyService: {
                ...dependentSchema.countyService,
                value: dataTitular?.countyService?.lookup,
            },
            congenerName: {
                ...dependentSchema.congenerName,
                value: dataTitular?.congenerName?.value,
            },
            height: {
                ...dependentSchema.height,
                required: dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired,
                error: '',
            },
            weight: {
                ...dependentSchema.weight,
                required: dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired,
                error: '',
            },
            enrollmentSequence: {
                ...dependentSchema.enrollmentSequence,
                required: dataActiveContract.parametros.obrigatorioInformarSequencialMatriculaFuncional,
            },
        };
    }

    const [showModalNoneAvaiablePlan, setShowModalNoneAvaiablePlan] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState(null);
    const [dataForm, setDataForm] = useState(() => {
        const dependentSchema = cloneObject(schema);

        if (dataDependentes.length) return dataDependentes.map((dependente) => getInitialValuesDependent(dependente));

        const initialValuesDependent = getInitialValuesDependent(dependentSchema);

        return [initialValuesDependent];
    });

    const [showForm, setShowForm] = useState(alreadyHasTitular || dataDependentes[0]?.cpf);

    async function loadGrauParentescos() {
        const parentescos = await getGrauParentesco(
            dataTitular.healthPlan?.value,
            dataActiveContract.numero,
            moment(dataActiveContract?.dataUltimaVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD')
        );

        if ((parentescos && parentescos.length) || dataActiveContract.permitePlanoDifDependente) {
            setKinshipDegreeOptions({
                [dataTitular.healthPlan?.value]: [...parentescos],
            });
        }
    }

    useEffect(() => {
        if (!dataTitular.cpf) {
            history.push('/movimentacao_cadastral/adicionar_beneficiario');
        }

        if (!Object.keys(kinshipDegreeOptions).length) loadGrauParentescos();
    }, []);

    async function validateAllCpfs(payloads) {
        const promises = payloads.map(async (payload) => {
            const { cpfExistente } = (await validaCpfDuplicidade(payload)) || {};

            return cpfExistente;
        });

        const responses = await Promise.all(promises);

        return responses;
    }

    function checkHasAvaiablePlans() {
        const isPlanAvaiable = dataActiveContract.planos.find(
            ({ codigo }) => codigo === dataTitular?.healthPlan?.value?.toString()
        )?.codigo;

        return isPlanAvaiable;
    }

    async function handleFowardStep() {
        const hasAvaiablePlan = checkHasAvaiablePlans();

        if (!hasAvaiablePlan) {
            setShowModalNoneAvaiablePlan(true);

            return;
        }

        const { validatedForm, isValid } = validate(dataForm);

        const payloads = [];

        if (isValid) {
            validatedForm.forEach(async (dependente) => {
                // Entao valida duplicidade de CPF
                const payload = {
                    numContrato: dataActiveContract.numero,
                    codigoPlano: dependente.healthPlan.value,
                    dtNascimento: dependente.birth.value,
                    cpf: dependente.cpf.unmaskedValue,
                    lackGroup: dependente.lackGroup.value,
                    nome: dependente.fullName.value,
                    situacao: dataActiveContract.situacaoAtual === 'A' ? 'ATIVO' : 'INATIVO',
                };

                payloads.push(payload);
            });

            const validations = await validateAllCpfs(payloads);

            const cpfDuplicated = validations.some((validation) => validation);

            if (cpfDuplicated) {
                setModalMessage('Este CPF já está cadastrado no sistema. Adicione outro para o novo beneficiário.');

                setShowModal(true);

                return;
            }
        }

        setDataForm([...validatedForm]);

        if (isValid) {
            setDataDependentes([...validatedForm]);

            history.push({
                pathname: '/movimentacao_cadastral/upload_documentos',
                alreadyHasTitular: false,
            });
        } else {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 300);
        }
    }

    function handleAddDependent() {
        const dependentSchema = cloneObject(schema);

        const initialValues = getInitialValuesDependent(dependentSchema);

        setDataForm([...dataForm, initialValues]);
    }

    function handleRemoveDependent(index) {
        const dependents = [...dataForm];

        dependents.splice(index, 1);

        setDataForm([...dependents]);

        setShowForm(dependents.length > 0 || alreadyHasTitular);
    }

    async function handleInputChange(event) {
        const { id: indexedId, value, unmaskedValue, lookup, sexo, tipo } = event;
        const [id, index] = indexedId.split('-');

        const newDataDependentes = cloneObject([...dataForm]);
        let kinshipDegreeMessage = null;

        // So valida CPF no sistema se estiver completo(tamanho === 11), assim evita lentidao
        if (id === 'cpf' && unmaskedValue.length === 11) {
            let cpfValidationMessage = null;

            if (dataTitular.cpf.unmaskedValue === unmaskedValue) {
                cpfValidationMessage = 'Este CPF é da pessoa titular. Adicione outro para a pessoa dependente.';

                setModalMessage(cpfValidationMessage);

                setShowModal(true);

                return;
            }

            const alreadyHasOtherDependente = dataForm.filter(
                (dependente, dependenteIndex) =>
                    dependenteIndex !== index && dependente.cpf.unmaskedValue === unmaskedValue
            );

            if (alreadyHasOtherDependente.length > 0) {
                cpfValidationMessage = `Este CPF é do dependente ${index
                    .toString()
                    .padStart(2, '0')}. Adicione outro para a pessoa dependente atual.`;
                setModalMessage(cpfValidationMessage);

                setShowModal(true);

                return;
            }
        }

        newDataDependentes[index][id] = {
            ...dataForm[index][id],
            lookup,
            value,
            unmaskedValue,
            error: '',
            sexo,
            tipo,
        };

        if (
            newDataDependentes[index].kinshipDegree.sexo &&
            newDataDependentes[index].gender.value &&
            newDataDependentes[index].kinshipDegree.sexo !== newDataDependentes[index].gender.value &&
            newDataDependentes[index].kinshipDegree.sexo !== 'A'
        ) {
            kinshipDegreeMessage = "Campos 'Grau de parentesco' e 'Gênero' da mesma pessoa não combinam";
            setModalMessage(kinshipDegreeMessage);

            setShowModal(true);

            return;
        }

        if (id === 'healthPlan') {
            // newDataDependentes[index].kinshipDegree.value = '';

            if (!!value && !kinshipDegreeOptions[value]) {
                const response = await getGrauParentesco(
                    value,
                    dataActiveContract.numero,
                    moment(dataActiveContract.dataUltimaVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD')
                );

                if (response && response.length) {
                    const newOptions = cloneObject(kinshipDegreeOptions);

                    newOptions[value] = [...response];

                    setKinshipDegreeOptions(newOptions);
                }
            }
        }

        if (id === 'birth') {
            validateCpfAge(newDataDependentes, value, index);
        }

        setDataForm([...newDataDependentes]);
    }

    function handleInputBlur(event) {
        const { id: indexedId, name, value } = event.target;
        const [id, index] = indexedId ? indexedId.split('-') : name.split('-');

        const field = cloneObject(dataForm[index][id]);

        const newDataDependentes = cloneObject(dataForm);

        if (id === 'dateStartPlan') newDataDependentes[index].birth.error = '';

        if (id === 'birth') {
            newDataDependentes[index].dateStartPlan.error = '';
            newDataDependentes[index].weddingDate.error = '';
            newDataDependentes[index].dn.error = '';

            validators.weddingDate(newDataDependentes[index]);
            validators.dateStartPlan(newDataDependentes[index]);

            if (newDataDependentes[index].dn.value) {
                validators.dn(newDataDependentes[index]);
            }
        }

        // Valida data de casamento maior que data de admissão
        if (id === 'weddingDate' && field.value > dataTitular.admissionDate?.value) {
            field.error = 'Data posterior à data de admissão';
        }

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[id] === 'function') {
            validators[id](newDataDependentes[index]);
        }

        if (field.required && !value) {
            field.error = field.requiredMessage || 'Preencha com um valor válido.';

            newDataDependentes[index][id] = { ...dataForm[index][id], ...field };
        }

        setDataForm([...newDataDependentes]);
    }

    return (
        <PageContainer>
            <StepProgress
                steps={alreadyHasTitular ? steps.inclusaoDependentes : steps.inclusaoTitular}
                activeStep={2}
            />
            <MensagensAlertas />

            {!showForm ? (
                <S.CardQuestionAddDependentes>
                    <h2>Quer adicionar dependentes?</h2>
                    <S.ContainerButtons>
                        <Button
                            type="secondary"
                            onClick={() => {
                                handleFowardStep();
                                history.push({
                                    pathname: '/movimentacao_cadastral/upload_documentos',
                                });
                            }}
                        >
                            Não quero
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                setShowForm(true);

                                if (dataForm.length === 0) handleAddDependent();
                            }}
                        >
                            Sim, quero
                        </Button>
                    </S.ContainerButtons>
                </S.CardQuestionAddDependentes>
            ) : (
                <>
                    {alreadyHasTitular && (
                        <Accordion title="Dados de titular">
                            <FormContainer>
                                <Input
                                    field={{
                                        id: 'cardNumberHolder',
                                        label: 'N° da carteirinha',
                                        value: dataTitular.cardNumber?.value,
                                        disabled: true,
                                    }}
                                />
                                <Input
                                    field={{
                                        id: 'nameHolder',
                                        label: 'Nome completo',
                                        value: dataTitular.fullName?.value,
                                        disabled: true,
                                    }}
                                />
                                <Input
                                    field={{
                                        id: 'contractHolder',
                                        label: 'Contrato',
                                        value: `${dataActiveContract.numero} - ${dataActiveContract.nome}`,
                                        disabled: true,
                                    }}
                                />
                                <Input
                                    field={{
                                        id: 'companyHolder',
                                        label: 'Empresa',
                                        value: dataTitular.company?.lookup,
                                        disabled: true,
                                    }}
                                />
                            </FormContainer>
                        </Accordion>
                    )}

                    {dataForm.map((dependente, index) => {
                        if (dependente.kinshipDegree.tipo !== 'A') {
                            dependente.healthPlan.value = activeHealthPlan;
                        }

                        const numBlock = index + 1;

                        Object.keys(dependente).forEach((field) => {
                            if (field !== 'documents' && field !== 'planPrice') {
                                dependente[field].id = `${field}-${index}`;
                            }
                        });

                        dependente.kinshipDegree.options = kinshipDegreeOptions[dependente.healthPlan?.value] || [];

                        dependente.civilState.options = staticOptions.estadoCivil;

                        return (
                            <Accordion
                                key={`dependente-accordion-${numBlock}`}
                                title={`Dados de dependente - ${numBlock.toString().padStart(2, '0')}`}
                            >
                                <FormContainer>
                                    {dataActiveContract.permitePlanoDifAgregado &&
                                    dependente.kinshipDegree.tipo === 'A' ? (
                                        <Select
                                            field={{
                                                ...dependente.healthPlan,
                                                label:
                                                    dataActiveContract.isDental === 2
                                                        ? 'Plano Dental'
                                                        : dependente.healthPlan.label,
                                                // eslint-disable-next-line no-nested-ternary
                                                options: dataActiveContract.permitePlanoDifAgregado
                                                    ? dataActiveContract.planos
                                                    : dataActiveContract.planosVinculados,
                                                disabled:
                                                    !dataActiveContract.permitePlanoDifAgregado &&
                                                    !dependente.kinshipDegree.tipo === 'A',
                                            }}
                                            onChange={handleInputChange}
                                            onBlur={handleInputBlur}
                                        />
                                    ) : (
                                        <Select
                                            field={{
                                                ...dependente.healthPlan,
                                                label:
                                                    dataActiveContract.isDental === 2
                                                        ? 'Plano Dental'
                                                        : dependente.healthPlan.label,
                                                // eslint-disable-next-line no-nested-ternary
                                                options: dataActiveContract.permitePlanoDifAgregado
                                                    ? dataActiveContract.planos
                                                    : dataActiveContract.planosVinculados,
                                                disabled: !dataActiveContract.permitePlanoDifDependente,
                                            }}
                                            onChange={handleInputChange}
                                            onBlur={handleInputBlur}
                                        />
                                    )}

                                    <DatepickerMui
                                        field={dependente.dateStartPlan}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />

                                    <Input
                                        field={{
                                            ...dependente.stateService,
                                            disabled: true,
                                        }}
                                        onBlur={handleInputBlur}
                                    />
                                    <Input
                                        field={{
                                            ...dependente.countyService,
                                            disabled: true,
                                        }}
                                        onBlur={handleInputBlur}
                                    />

                                    {dataActiveContract.parametros.obrigatorioInformarMatriculaFuncionalDependente && (
                                        <Input
                                            field={{
                                                ...dataTitular.functionalEnrollment,
                                                disabled: true,
                                            }}
                                        />
                                    )}

                                    <Input
                                        field={dependente.enrollmentSequence}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />

                                    <Input field={dependente.congenerName} onBlur={handleInputBlur} />

                                    {dataActiveContract.isAdesao && (
                                        <Input
                                            field={{
                                                ...dependente.lackGroup,
                                                disabled: !dependente.healthPlan.value,
                                            }}
                                            onBlur={handleInputBlur}
                                            onChange={handleInputChange}
                                        />
                                    )}
                                </FormContainer>

                                <Divider />

                                <FormContainer>
                                    <Input
                                        field={dependente.cpf}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Radio
                                        field={dependente.nationality}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Input
                                        field={dependente.fullName}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Input
                                        field={dependente.socialName}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <DatepickerMui
                                        field={dependente.birth}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Select
                                        field={dependente.gender}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Input
                                        field={dependente.motherName}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Select
                                        field={dependente.civilState}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Select
                                        field={dependente.kinshipDegree}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <DatepickerMui
                                        field={dependente.weddingDate}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Input
                                        field={dependente.pis}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Input
                                        field={dependente.sus}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                    <Input
                                        field={dependente.dn}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                    />
                                </FormContainer>

                                {((dataActiveContract.isHealth && dataActiveContract.healthDeclarationRequired) ||
                                    dataActiveContract.isAdesao ||
                                    dataActiveContract.isPme) && (
                                    <div style={{ width: '100%' }}>
                                        <Accordion
                                            title={`Dados de saúde de dependente - ${numBlock
                                                .toString()
                                                .padStart(2, '0')}`}
                                        >
                                            <FormContainer>
                                                {dataActiveContract.isHealth &&
                                                    dataActiveContract.healthDeclarationRequired && (
                                                        <>
                                                            <Input
                                                                field={dependente.weight}
                                                                onBlur={handleInputBlur}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Input
                                                                field={dependente.height}
                                                                onBlur={handleInputBlur}
                                                                onChange={handleInputChange}
                                                            />
                                                        </>
                                                    )}
                                                {(dataActiveContract.isPme || dataActiveContract.isAdesao) && (
                                                    <InputTag
                                                        field={dependente.cid}
                                                        onBlur={handleInputBlur}
                                                        onChange={handleInputChange}
                                                    />
                                                )}
                                            </FormContainer>
                                        </Accordion>
                                    </div>
                                )}

                                {(!alreadyHasTitular || (alreadyHasTitular && dataForm.length > 1)) && (
                                    <S.LinkedButtonAlign>
                                        <S.LinkButton
                                            id={`removeDependent-${numBlock}`}
                                            onClick={() => handleRemoveDependent(index)}
                                        >
                                            <Icon name="delete" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                            <S.AddButton>Excluir dependente</S.AddButton>
                                        </S.LinkButton>
                                    </S.LinkedButtonAlign>
                                )}
                            </Accordion>
                        );
                    })}

                    <Divider />

                    <S.LinkButton id="addDependent" onClick={handleAddDependent} style={{ margin: '32px 0 32px 0px' }}>
                        <Icon name="group_add" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                        <S.AddButton>Adicionar dependente</S.AddButton>
                    </S.LinkButton>

                    <ContainerButton>
                        <Button
                            id="backStep"
                            type="secondary"
                            onClick={() => {
                                const backPath =
                                    flow === 'adicionar_titular' ? 'adicionar_titular' : 'selecionar_titular';

                                history.push(`/movimentacao_cadastral/${backPath}`);
                            }}
                            className="hide-mobile"
                        >
                            Voltar
                        </Button>

                        <Button id="continueStep" type="primary" onClick={handleFowardStep}>
                            Continuar
                        </Button>
                    </ContainerButton>

                    <Modal
                        title="Atenção"
                        subtitle={modalMessage}
                        modalSize="sm"
                        visible={showModal}
                        onCancel={() => setShowModal(false)}
                        footer={null}
                    >
                        <Button type="primary" onClick={() => setShowModal(false)}>
                            Revisar
                        </Button>
                    </Modal>

                    <Modal
                        title="Atenção"
                        subtitle="Não há planos vigentes para o beneficiário."
                        modalSize="sm"
                        visible={showModalNoneAvaiablePlan}
                        onCancel={() => setShowModalNoneAvaiablePlan(false)}
                        footer={null}
                    >
                        <Button type="primary" onClick={() => setShowModalNoneAvaiablePlan(false)}>
                            OK
                        </Button>
                    </Modal>
                </>
            )}
        </PageContainer>
    );
}

export default Dependente;
